import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import PrivacyDialog from "@/components/PrivacyDialog";
import { Users, CalendarDays, ShieldCheck, LogOut, Network } from "lucide-react";

const KiwanisMark = () => (
  <div className="flex items-center" data-testid="brand-logo">
    <img src="/kiwanis-logo.jpeg" alt="Kiwanis Distretto Italia-San Marino" className="h-11 w-auto object-contain" />
  </div>
);

const NavItem = ({ to, icon: Icon, label, active, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${
      active ? "bg-navy text-white" : "text-navy hover:bg-navy/10"
    }`}
  >
    <Icon className="w-5 h-5" strokeWidth={2} />
    <span className="hidden md:inline">{label}</span>
  </Link>
);

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen">
      <PrivacyDialog />
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-navy/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/"><KiwanisMark /></Link>
          <nav className="flex items-center gap-1 sm:gap-2">
            <NavItem to="/" icon={Users} label="Soci" active={loc.pathname === "/" || loc.pathname.startsWith("/soci")} testid="nav-soci" />
            <NavItem to="/distretto" icon={Network} label="Distretto" active={loc.pathname.startsWith("/distretto")} testid="nav-distretto" />
            <NavItem to="/eventi" icon={CalendarDays} label="Eventi & News" active={loc.pathname === "/eventi"} testid="nav-eventi" />
            {user?.role === "admin" && (
              <NavItem to="/admin" icon={ShieldCheck} label="Admin" active={loc.pathname === "/admin"} testid="nav-admin" />
            )}
          </nav>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-navy-deep leading-tight">{user?.name || user?.email}</p>
              <p className="text-[10px] uppercase tracking-wider text-gold font-bold">{user?.role === "admin" ? "Amministratore" : "Socio"}</p>
            </div>
            <Button variant="ghost" size="icon" onClick={doLogout} data-testid="logout-btn" className="text-navy hover:bg-navy/10">
              <LogOut className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 animate-fade-in-up">{children}</main>
      <footer className="border-t border-navy/10 mt-12 py-6 text-center text-xs text-muted-foreground">
        <p>Kiwanis Distretto Italia-San Marino · Elenco soci riservato</p>
        <p className="mt-1">Realizzato gratuitamente per KDISM da Giorgio Palma</p>
      </footer>
    </div>
  );
}
